import styled from 'styled-components';
import Card from 'gatsby-theme-pagebuilder/src/components/column/card';

const BoksCard = styled(Card)`
  padding: 2rem 1rem;
`;

export default BoksCard;
